import {FEATURE_FLAGS, MODULE_TYPES} from '../../../constants';
import {hasFeatureFlag} from './FeatureUtil';
import {hasModule} from './ModuleUtil';

/**
 * FOR-48 (BU-10): whether the Customer Portal PSA config surfaces are *available*
 * to the current company/person.
 *
 * Gated by EITHER the `CUSTOMER_PORTAL` module OR the `customer_portal` feature
 * flag, mirroring `isTicketingAvailable` (ACC-461): module customers get it
 * automatically, while the flag enables staged rollout / internal dogfooding.
 *
 * This governs *availability* only — per-person *access* to author config is gated
 * separately by the account-settings permission, which callers check alongside this.
 */
export const isCustomerPortalAvailable = (): boolean =>
	hasModule(MODULE_TYPES.CUSTOMER_PORTAL) || hasFeatureFlag(FEATURE_FLAGS.CUSTOMER_PORTAL);
